import "./OurValues.css";

function OurValues() {
  return (
    <section className="hp-values">
      <h2 className="sp-section-title hp-values-title">Nos valeurs</h2>
      <p className="sp-values-intro">
        Comme de nombreuses entreprises, SOUDRY Préventions et Équipements est
        fondée sur des valeurs. Elles sont essentielles pour favoriser un
        environnement de travail positif et productif. Nos valeurs incluent
        l'écoute attentive, l'efficience, la collaboration, le partage des
        connaissances et la confiance.
      </p>
      <div className="sp-values-table">
        <div className="sp-vtable-row">
          <span className="sp-vtable-name">Écoute</span>
          <span className="sp-vtable-desc">
            Permettre de comprendre les besoin et les préoccupations de chacun.
          </span>
        </div>
        <div className="sp-vtable-row">
          <span className="sp-vtable-name">Efficience</span>
          <span className="sp-vtable-desc">
            Être efficace tout en garantissant une utilisation optimale des
            ressources.
          </span>
        </div>
        <div className="sp-vtable-row">
          <span className="sp-vtable-name">Collaboration / Partage</span>
          <span className="sp-vtable-desc">
            Favoriser l'innovation et la croissance collective.
          </span>
        </div>
        <div className="sp-vtable-row">
          <span className="sp-vtable-name">Confiance</span>
          <span className="sp-vtable-desc">
            Des bases relationnelle solides et durables.
          </span>
        </div>
      </div>
      <p className="sp-values-content">
        Ces valeurs sont des atouts précieux pour nos clients et notre
        entreprise.
      </p>
    </section>
  );
}

export default OurValues;
